import React, { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import OnboardingLayout from '../OnboardingLayout';
import AnimatedStep from './AnimatedStep';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import '../../../styles/Onboarding.css';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormData } from '../../../redux/onboarding/onboardingSlice'; 

const StepProfileBasics = ({ data, setData, setStepValidity }) => {
  const dispatch = useDispatch();
  const { displayName, location, lat, lng } = data;
  console.log("StepProfileBasics onload data", data)
  const { user } = useSelector((state) => state.auth);

  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [locationError, setLocationError] = useState(null);
  const [address, setAddress] = useState(location || '');

  const lastValidityRef = useRef(null);

  // Initialize Google Maps API load state
  useEffect(() => {
    if (window.google && window.google.maps) {
      setGoogleLoaded(true);
    } else {
      const interval = setInterval(() => {
        if (window.google && window.google.maps) {
          setGoogleLoaded(true);
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, []);


  // Reactive validation: Update validity when fields change
  useEffect(() => {
    const isValid =
      displayName?.trim() &&
      address?.trim() &&
      typeof lat === 'number' &&
      typeof lng === 'number';

    if (lastValidityRef.current !== isValid) {
      console.log("SteoProfileBasics useEffect", data);
      lastValidityRef.current = isValid;
      setStepValidity(isValid);
    }
  }, [setStepValidity]);

  // Handle geolocation button
  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setData((prev) => ({
          ...prev,
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          location: 'Detected via browser',
        }));
        setAddress('Detected via browser');
        setLocationError(null);
      },
      () => setLocationError("Unable to retrieve your location")
    );
  };

  // Handle location selection from autocomplete
  const handleSelectLocation = async (selected) => {
    try {
      const results = await geocodeByAddress(selected);
      const coords = await getLatLng(results[0]);

      console.log("SteoProfileBasics handleSelectLocation selected location", selected)

      // Update Redux store using dispatch
      dispatch(updateFormData({
        ...data,  // keep existing data
        lat: coords.lat,
        lng: coords.lng,
      }));

      console.log("SteoProfileBasics handleSelectLocation data", data)
      setAddress(selected);
      setLocationError(null);
    } catch (error) {
      console.error('Error resolving location:', error);
      setLocationError('Could not resolve location.');
    }
  };

  return (
    <OnboardingLayout>
      <AnimatedStep>
        <Form>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Display Name</Form.Label>
                <Form.Control
                  type="text"
                  value={displayName || ''}
                  onChange={(e) =>{
                    const updatedData = { ...data, displayName: e.target.value };
                    console.log("Updated Data:", updatedData); // Log the updated data
                    setData(updatedData); // Update the state correctly
                  }}
                  placeholder="Enter your display name"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Location</Form.Label>
                {googleLoaded ? (
                  <PlacesAutocomplete
                    value={address}
                    onChange={(val) => {
                      setAddress(val);
                      setData((prev) => ({
                        ...prev,
                        location: val,
                        lat: null,
                        lng: null,
                      }));
                    }}
                    onSelect={handleSelectLocation}
                    debounce={300}
                  >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                      <div>
                        <Form.Control
                          {...getInputProps({
                            placeholder: 'Search for your city or address...',
                            className: 'location-search-input',
                          })}
                        />
                        <div className="autocomplete-dropdown-container">
                          {loading && <div>Loading...</div>}
                          {suggestions.map((suggestion) => {
                            const className = suggestion.active
                              ? 'suggestion-item--active'
                              : 'suggestion-item';
                            return (
                              <div
                                {...getSuggestionItemProps(suggestion, { className })}
                                key={suggestion.placeId}
                              >
                                <span>{suggestion.description}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </PlacesAutocomplete>
                ) : (
                  <div>Loading Google Maps...</div>
                )}
              </Form.Group>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleGetLocation}
                className="mt-2"
              >
                Or use my current location
              </Button>

              {locationError && (
                <Alert variant="danger" className="mt-2">
                  {locationError}
                </Alert>
              )}
            </Col>
          </Row>
        </Form>
      </AnimatedStep>
    </OnboardingLayout>
  );
};

export default StepProfileBasics;
